export { buildIcs, type IcsInput } from '../../shared/ics/ics';

/** The browser's half of the calendar export: handing the file over. `buildIcs` is shared with the feed. */

export function downloadIcs(content: string, filename = 'commonground-nyc.ics'): void {
  downloadFile(content, filename, 'text/calendar;charset=utf-8');
}

/** Hands the browser a file to save: the .ics, and the backup. */
export function downloadFile(content: string, filename: string, type: string): void {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Give the browser a moment to start the download before revoking.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
